import { LessonStatus } from "@repo/app-types/entities/trainingParticipant";
import { assertUnreachable } from "@repo/app-types/helpers/utilities";
import {
  IconClock,
  IconLock,
  IconPlayerPlay,
  IconRosetteDiscountCheck,
  IconSparkles,
} from "@tabler/icons-react";
import type { FC } from "react";
import { VisuallyHidden } from "react-aria";

export interface LessonItemStatusIndicatorProps {
  status: LessonStatus;
}

export const LessonItemStatusIndicator: FC<LessonItemStatusIndicatorProps> = (
  props,
) => {
  switch (props.status) {
    case LessonStatus.Unavailable:
      return (
        <>
          <IconLock className="size-5 text-muted-foreground" />
          <VisuallyHidden>Unavailable</VisuallyHidden>
        </>
      );

    case LessonStatus.Pending:
      return (
        <>
          <IconPlayerPlay className="size-5 text-indigo-500" />
          <VisuallyHidden>Next up</VisuallyHidden>
        </>
      );

    case LessonStatus.InProgress:
      return (
        <>
          <IconClock className="size-5 text-indigo-500" />
          <VisuallyHidden>In progress</VisuallyHidden>
        </>
      );

    case LessonStatus.Submitted:
      return (
        <>
          <IconSparkles className="size-5 text-purple-500" />
          <VisuallyHidden>Submitted</VisuallyHidden>
        </>
      );

    case LessonStatus.Completed:
      return (
        <>
          <IconRosetteDiscountCheck className="size-5 text-lime-500" />
          <VisuallyHidden>Completed</VisuallyHidden>
        </>
      );

    default:
      return assertUnreachable(props.status, () => null);
  }
};
